import script from "./HiddenFieldV2.vue?vue&type=script&lang=ts"
export * from "./HiddenFieldV2.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__